import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';

const videoTriggerButtonStyles = tv({
    slots: {
        button: [
            `iris:group
      iris:cursor-pointer
      iris:overflow-hidden
      iris:rounded-(--comp-size-radius-video-trigger-button)
      iris:border-(length:--comp-size-border-video-trigger-button)
      iris:border-(--comp-color-border-video-trigger-button-rest)
      iris:bg-(--comp-color-background-video-trigger-button-rest)
      iris:transition-all
      iris:hover:border-(--comp-color-border-video-trigger-button-hover)
      iris:hover:bg-(--comp-color-background-video-trigger-button-hover)
      iris:active:border-(--comp-color-border-video-trigger-button-pressed)
      iris:active:bg-(--comp-color-background-video-trigger-button-pressed)`,
            focusStyles.default,
        ],
        wrapper: [],
        icon: [
            `iris:pl-(--comp-space-padding-carousel-button-icon-nudge)
      iris:text-(--comp-color-content-video-trigger-button-icon-rest)
      iris:transition-all
      iris:group-hover:text-(--comp-color-content-video-trigger-button-icon-hover)
      iris:group-active:text-(--comp-color-content-video-trigger-button-icon-pressed)
      `,
        ],
    },
    variants: {
        size: {
            md: {
                wrapper: `iris:h-(--comp-size-box-video-trigger-button-md) iris:w-(--comp-size-box-video-trigger-button-md)
        iris:p-(--comp-space-padding-video-trigger-button-md)
        `,
                icon: "iris:size-(--comp-size-icon-video-trigger-button-md)",
            },
            lg: {
                wrapper: `iris:h-(--comp-size-box-video-trigger-button-lg) iris:w-(--comp-size-box-video-trigger-button-lg)
        iris:p-(--comp-space-padding-video-trigger-button-lg)
        `,
                icon: "iris:size-(--comp-size-icon-video-play-button-lg)",
            },
        },
    },
    defaultVariants: {
        size: "md",
    },
});

export { videoTriggerButtonStyles as default };
